import _extends from '../../../node_modules/@babel/runtime/helpers/extends.js';
import _slicedToArray from '../../../node_modules/@babel/runtime/helpers/slicedToArray.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import { useState, useMemo } from 'react';
import 'prop-types';
import { jsx } from '@emotion/core';
import merge from 'deepmerge';
import { RadioContext } from './RadioContext.js';
import { fieldset } from '../../styles/elements/fieldset.js';
import noop from '../../utils/noop.js';
import getPreferredValue from '../../utils/getPreferredValue.js';
import { label3 } from '../../styles/typography/label3.js';

function RadioGroup(_ref) {
  var children = _ref.children,
      defaultChecked = _ref.defaultChecked,
      checked = _ref.checked,
      onChange = _ref.onChange,
      theme = _ref.theme,
      otherProps = _objectWithoutProperties(_ref, ["children", "defaultChecked", "checked", "onChange", "theme"]);

  var override = typeof checked !== 'undefined';

  var _useState = useState(defaultChecked),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  function handleSelect(event) {
    if (!override) {
      setSelected(event.target.value);
      onChange(event, event.target.value);
    } else {
      onChange(event);
    }
  }

  var selectedValue = getPreferredValue(checked, selected);
  var fieldsetCss = useMemo(function () {
    return merge.all([fieldset, {
      legend: label3
    }, theme]);
  }, [theme]);
  return jsx(RadioContext.Provider, {
    value: {
      selectedValue: selectedValue,
      handleSelect: handleSelect
    }
  }, jsx("fieldset", _extends({
    css: fieldsetCss
  }, otherProps), children));
}

RadioGroup.defaultProps = {
  defaultChecked: '',
  checked: undefined,
  onChange: noop,
  theme: {}
};

export default RadioGroup;
